import JustValidate from 'just-validate'

const emailForm = document.getElementById('email-form')

const emailFormValidation = () => {
	if (!emailForm) {
		return
	}
	const validator = new JustValidate('#email-form')
	validator.addField('#email-subscribe', [
		{
			rule: 'required'
		},
		{
			rule: 'email'
		}
	])
}

emailFormValidation()
